interface SectionHeadingProps {
  id?: string;
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  id,
  eyebrow,
  title,
  description,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  const alignClass = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";

  return (
    <div className={`flex flex-col ${alignClass} max-w-2xl`}>
      {eyebrow ? (
        <span
          className={`mb-3 inline-flex items-center gap-2 text-xs font-medium tracking-[0.28em] ${
            light ? "text-accent-300" : "text-primary-600"
          }`}
        >
          <span className={`h-px w-6 ${light ? "bg-accent-300" : "bg-primary-500"}`} />
          {eyebrow}
        </span>
      ) : null}
      <h2
        id={id}
        className={`font-heading text-2xl font-bold leading-snug text-balance md:text-4xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description ? (
        <p className={`mt-4 text-sm leading-relaxed md:text-base ${light ? "text-background-200" : "text-foreground-600"}`}>
          {description}
        </p>
      ) : null}
    </div>
  );
}